import { Forms } from "@/types/form";
import { Actor } from "@/types/utils";
import storage from "@/utils/storage";
import { create } from "zustand";

interface IntitialState {
  user: Forms["VendorUser"] | null;
  actorType: Actor["actor_type"] | null;
  isAuthenticated: boolean;
  globalLoading: boolean;
}

interface Actions {
  setGlobalLoading: (bool: boolean) => void;
  login(user: Forms["VendorUser"], actorType: Actor["actor_type"]): void;
  logout(): void;
  update: (
    user: Forms["VendorUser"] | null,
    actorType: Actor["actor_type"] | null
  ) => void;
}

const initialState: IntitialState = {
  user: null,
  actorType: null,
  isAuthenticated: false,
  globalLoading: false,
};

export const useUser = create<IntitialState & Actions>((set) => ({
  ...initialState,
  setGlobalLoading: (globalLoading) => set({ globalLoading }),
  login: (user, actorType) => {
    const { vendor_id: vid } = user;

    set({ user, isAuthenticated: true, actorType });

    storage.setItem("vid", vid as string);
    storage.setItem("last_login", Date.now());
  },
  logout: () => {
    set({ user: null, isAuthenticated: false });
    storage.clear();
  },
  update: (user, actorType) => {
    set({
      user,
      isAuthenticated: !!user,
      actorType,
    });
  },
}));
